import React from 'react';
import './NavBar.css';

// Import des assets depuis containers
import navBarBackGround from '../../containers/assets/navBar/footer_vague_bleue.svg';
import navBarPicto_analyse from '../../containers/assets/navBar/picto_analyse.png';
import navBarPicto_calcul_volume_eau from '../../containers/assets/navBar/picto_calcul_volume_eau.png';
import navBarPicto_home from '../../containers/assets/navBar/picto_home.png';
import navBarPicto_Historique from '../../containers/assets/navBar/picto_historique.png';
import navBarPicto_Revendeur from '../../containers/assets/navBar/picto_revendeur.png';

// Variantes sans libelle incruste, pour le menu desktop : celui-ci affiche deja
// le libelle en HTML sous l'icone, le texte grave dans l'image faisait doublon.
// Le menu mobile continue d'utiliser les pictos d'origine, ou le texte incruste
// tient lieu de libelle.
import navBarPictoNu_analyse from '../../containers/assets/navBar/picto_analyse_sans_texte.svg';
import navBarPictoNu_calcul_volume_eau from '../../containers/assets/navBar/picto_calcul_volume_eau_sans_texte.svg';
import navBarPictoNu_home from '../../containers/assets/navBar/picto_home_sans_texte.svg';
import navBarPictoNu_Historique from '../../containers/assets/navBar/picto_historique_sans_texte.svg';
import navBarPictoNu_Revendeur from '../../containers/assets/navBar/picto_revendeur_sans_texte.svg';

const NavBar = () => {
  // Configuration des éléments de navigation
  const navItems = [
    {
      key: 'analyse',
      path: '/forms',
      icon: navBarPictoNu_analyse,
      label: 'Analyse'
    },
    {
      key: 'simulateur',
      path: '/simulateur',
      icon: navBarPictoNu_calcul_volume_eau,
      label: 'Volume'
    },
    {
      key: 'home',
      path: '/',
      icon: navBarPictoNu_home,
      label: 'Accueil'
    },
    {
      key: 'historique',
      path: '/historique',
      icon: navBarPictoNu_Historique,
      label: 'Historique'
    },
    {
      key: 'revendeur',
      path: 'https://www.hydrapro.fr/app/uploads/storelocator0106/wordpress/hydrapro/index.html',
      icon: navBarPictoNu_Revendeur,
      label: 'Revendeur',
      external: true
    }
  ];

  return (
    <>
      {/* Menu Desktop - visible >= 1200px */}
      <nav className="navbar-desktop">
        <div className="navbar-desktop-container">
          {navItems.map(item => (
            <div key={item.key} className="navbar-desktop-item">
              <a
                href={item.path}
                target={item.external ? '_blank' : '_self'}
                rel={item.external ? 'noopener noreferrer' : undefined}
              >
                <img
                  src={item.icon}
                  alt={item.label}
                  width="40px"
                  height="40px"
                />
                <span>{item.label}</span>
              </a>
            </div>
          ))}
        </div>
      </nav>

      {/* Menu Mobile Bottom Bar - visible < 1200px */}
      <nav
        className="navbar-mobile"
        style={{
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage: `url(${navBarBackGround})`
        }}
      >
        <div className="navbar-mobile-container">
          <div className="navbar-mobile-item">
            <a href="/forms">
              <img loading="lazy" width="50px" height="50px" src={navBarPicto_analyse} alt="Analyse" />
            </a>
          </div>
          <div className="navbar-mobile-item">
            <a href="/simulateur">
              <img loading="lazy" width="50px" height="50px" src={navBarPicto_calcul_volume_eau} alt="Volume" />
            </a>
          </div>
          <div className="navbar-mobile-item">
            <a href="/">
              <img loading="lazy" width="50px" height="50px" src={navBarPicto_home} alt="Accueil" />
            </a>
          </div>
          <div className="navbar-mobile-item">
            <a href="/historique">
              <img loading="lazy" width="50px" height="50px" src={navBarPicto_Historique} alt="Historique" />
            </a>
          </div>
          <div className="navbar-mobile-item">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.hydrapro.fr/app/uploads/storelocator0106/wordpress/hydrapro/index.html"
            >
              <img loading="lazy" width="50px" height="50px" src={navBarPicto_Revendeur} alt="Revendeur" />
            </a>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
